"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Repeater = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("../Button"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var Repeater = function Repeater(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      id = _ref.id,
      minimumQuantity = _ref.minimumQuantity,
      maximumQuantity = _ref.maximumQuantity,
      component = _ref.component,
      values = _ref.values,
      initialValue = _ref.initialValue,
      setValues = _ref.setValues,
      fullWidth = _ref.fullWidth,
      addButtonText = _ref.addButtonText,
      removeButtonText = _ref.removeButtonText,
      disabled = _ref.disabled;

  if (maximumQuantity && values.length > maximumQuantity) {
    // eslint-disable-next-line no-console
    console.warn("There are more values passed than the provided maximumQuantity. Please check your props.");
  }

  if (minimumQuantity && values.length < minimumQuantity) {
    // eslint-disable-next-line no-console
    console.warn("There are fewer values passed than the provided minimumQuantity. Please check your props.");
  }

  var handleAdd = function handleAdd() {
    var newValues = [].concat((0, _toConsumableArray2.default)(values), [initialValue]);
    setValues(newValues);
  };

  var handleRemove = function handleRemove(index) {
    var newValues = (0, _toConsumableArray2.default)(values);
    newValues.splice(index, 1);
    setValues(newValues);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: (0, _classnames.default)("prmbl-repeater", className, classes.root)
  }, values.map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement(_Collapse.default, {
      className: "prmbl-repeater-item",
      in: true,
      appear: true,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      alignItems: "center",
      direction: "row",
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: "auto",
      className: (0, _classnames.default)("prmbl-repeater-components", (0, _defineProperty2.default)({}, classes.fullWidth, fullWidth))
    }, component(value, function (value) {
      var newValues = (0, _toConsumableArray2.default)(values);
      newValues[index] = value;
      setValues(newValues);
    }, index)), (minimumQuantity && values.length > minimumQuantity || !minimumQuantity) && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: "auto"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: (0, _classnames.default)("prmbl-repeater-removeButton", classes.repeaterButton),
      type: "icon",
      size: "small",
      onClick: function onClick() {
        return handleRemove(index);
      },
      title: removeButtonText
    }, /*#__PURE__*/_react.default.createElement(_Clear.default, null)))));
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _classnames.default)("prmbl-repeater-addButton", classes.addButton),
    color: "primary",
    size: "small",
    disabled: maximumQuantity !== undefined && values.length >= maximumQuantity || disabled,
    onClick: handleAdd
  }, /*#__PURE__*/_react.default.createElement(_Add.default, {
    className: classes.addFieldIcon
  }), " ", addButtonText));
};

exports.Repeater = Repeater;
Repeater.defaultProps = {
  fullWidth: false,
  addButtonText: "Add Field",
  removeButtonText: "Remove Field"
};

var _default = (0, _styles2.withStyles)(_styles.styles)(Repeater);

exports.default = _default;